module.exports = __webpack_public_path__ + "img/package.362e4fe0.png";